import { masterAPIClient } from '@/clients/MasterAPIClient';
import { useQuery } from '@tanstack/react-query';

export default function useGetPackagingQuery(formatId?: number | null) {
  return useQuery({
    queryKey: ['packagings', formatId],
    queryFn: () => masterAPIClient.getPackaging(formatId ?? null),
    staleTime: Infinity,
  });
}
